import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import '../styles/styles.css';
import MiFoto from '../assets/images/mifoto.jpg';
import Skills from '../components/Skills';
import Xp from '../components/Xp';

function SobreMi() {
  useEffect(() => {
    document.body.classList.add('body-sobremi');
    return () => {
      document.body.classList.remove('body-sobremi');
    };
  }, []);

  return (
    <>
      <Navbar />

      <section className="sobremi-section">
        {/* 🎥 Video de fondo */}
        <video
          className="sobremi-video"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/videos/fondito.mp4" type="video/mp4" />
          Tu navegador no soporta el video HTML5.
        </video>

        <div className="sobremi-content">
          <div className="sobremi-box">
            <h1 className="sobremi-titulo">Sobre Mí</h1>
            <p className="sobremi-descripcion">
              ¡Hola! Soy Fabianna, desarrolladora de software con enfoque en diseño UI/UX.
              Me encanta transformar ideas en experiencias digitales elegantes, funcionales y accesibles.
              Trabajo con pasión en cada proyecto para asegurarme de que el resultado final refleje
              tanto las necesidades del cliente como una excelente experiencia para el usuario.
            </p>

            <p className="sobremi-descripcion">
              Tengo experiencia desarrollando proyectos para empresas, integrando diseño visual,
              código limpio, y estructura organizada tanto en frontend como en backend.
            </p>

            <p className="sobremi-descripcion">
              Si tienes una idea, ¡yo puedo ayudarte a hacerla realidad!
            </p>
            <div className="sobremi-nav-botones">
  <button onClick={() => document.getElementById('skills-section').scrollIntoView({ behavior: 'smooth' })}>
    Habilidades
  </button>
  <button onClick={() => document.getElementById('experiencia-section').scrollIntoView({ behavior: 'smooth' })}>
    Experiencia
  </button>
</div>

            <a
              href="/docs/hoja-de-vida.pdf"
              download
              className="sobremi-descarga-btn"
            >
              Descarga mi hoja de vida
            </a>
            <div
              className="scroll-down-icon"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '2rem',
                marginTop: '2rem',
                color: '#00ffe0'
              }}
            >
              ↓
            </div>

          </div>

          <div className="sobremi-foto-container">
            <img src={MiFoto} alt="Foto Fabianna" className="sobremi-foto" />
          </div>
        </div>
        
      </section>

      <section  id="skills-section" className="sobremi-section">
    
      <video
          className="sobremi-video"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/videos/teddy.mp4" type="video/mp4" />
          Tu navegador no soporta el video HTML5.
        </video>
        <Skills />
        
      </section>
      <section id="experiencia-section" className="sobremi-section">
        <video
          className="sobremi-video"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/videos/portfolio.mp4" type="video/mp4" />
          Tu navegador no soporta el video HTML5.
        </video>
        <Xp />

      </section>
    </>
    
  );
}

export default SobreMi;
